/**
 * Train = PvE vs the standard `bot` from the main menu — no battle_rewards.
 * Explore Unknown, campaign, war effort, and autobattler are excluded.
 *
 * @param {object | null | undefined} gameState
 * @returns {boolean}
 */
export function isTrainPvEBattle(gameState) {
  if (!gameState || !Array.isArray(gameState.players)) {
    return false;
  }
  if (!gameState.players.includes('bot')) {
    return false;
  }
  if (gameState.players.includes('campaign_bot')) {
    return false;
  }
  if (gameState.campaignMode) {
    return false;
  }
  if (gameState.isAutobattler) {
    return false;
  }
  if (gameState.warEffortMissionId || gameState.isWarEffort) {
    return false;
  }
  if (gameState.exploreUnknownMissionIndex != null) {
    return false;
  }
  return true;
}
